export const validateName = async (rule,value) => {
    if(value && value.length < 2){
        throw new Error('Debe tener al menos 2 caracteres de longitud');
    }

    if(value && !(/^[a-zA-ZÑñáéíóúÁÉÍÓÚ\s.'-]+$/).test(value)){
        throw new Error('Debe contener solamente caracteres alfabeticos');
    }
}

export const validateModelSKU = async (rule,value) => {
    if(value && !(/^(?=.*[A-Z])(?=.*\d)[^\s]+$/.test(value))){
        throw new Error('Debe tener caracteres alfanumericos en mayuscula');
    }
}

export const validateSize = async (rule,value) => {
    if(value && !( value > 1 && value < 60)){
        throw new Error('Debe ser un numero entre 2 y 60');
    }
}

export const validateColor = async (rule,value) => {
    if(value && !(/^[a-z\s]+$/.test(value))){
        throw new Error('Solamente caracteres alfabeticos en minuscula');
    }
}

export const validateCharacteristics = async (rule,value) => {
    if(value && (value.length < 5 || value.length > 300)){
        throw new Error('Debe tener una longitud de minima de 5 caracteres');
    }
}

export const validatePrice = async (rule,value) => {
    if(value && !(/^\d+(?:\.\d{1,2})?$/.test(value))){
        throw new Error('Entrar un precio con maximo dos decimales');
    }
}

export const validateProvider = async (rule, value) => {
    if(value && value.length < 2){
        throw new Error('Debe tener al menos 2 caracteres de longitud');
    }

    if(value && !(/^[a-zA-Z0-9.,\s]+$/).test(value)){
        throw new Error('Debe contener solamente caracteres alfanumericos, puntos y comas');
    }
}